import { getTelegramWebApp, isTMA } from '@web/libs/tg/platform'

export const isTelegramMiniApp = (): boolean => isTMA()

export function getTelegramUserName(): string | undefined {
  const user = getTelegramWebApp()?.initDataUnsafe.user
  return [user?.first_name, user?.last_name].filter(Boolean).join(' ') || undefined
}
